export const IFairLaunchFactory = [
    'function locker() external view returns (address)',
]